import { useRef, useState } from 'react';
import PropTypes from 'prop-types';

const BrDropdown = ({
  label,
  iconToShow,
  iconToHide,
  useIcons,
  className,
  children,
}) => {
  const [active, setActive] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => {
    const close = () => {
      setActive(false);
      document.removeEventListener('mousedown', handleClickOutside);
    };

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        close();
      }
    };

    if (active) {
      close();
    } else {
      setActive(true);
      document.addEventListener('mousedown', handleClickOutside);
    }
  };

  return (
    <div
      ref={dropdownRef}
      className={`dropdown${active ? ' show' : ''} ${className}`}
    >
      <button
        className={`br-button small${useIcons ? ' circle' : ''}${
          active ? ' active' : ''
        }`}
        type="button"
        data-toggle="dropdown"
        title={useIcons ? label : null}
        onClick={toggleDropdown}
      >
        {useIcons ? (
          <span
            className={active ? iconToHide : iconToShow}
            aria-hidden="true"
          ></span>
        ) : (
          { label }
        )}
      </button>

      {children}
    </div>
  );
};

BrDropdown.propTypes = {
  label: PropTypes.string,
  iconToShow: PropTypes.string,
  iconToHide: PropTypes.string,
  useIcons: PropTypes.bool,
  className: PropTypes.string,
};

BrDropdown.defaultProps = {
  iconToShow: 'fas fa-chevron-down',
  iconToHide: 'fas fa-chevron-up',
  useIcons: true,
  className: '',
};

export default BrDropdown;
